/**
 * Precedence for the caution modals raised when saving an edited Key Result.
 *
 * A single save can trip more than one caution. Only the most restrictive may be
 * shown: offering "retain updates" alongside a change that erases them regardless
 * tells the user something the save will not honor (OKR-10954).
 */

export const KR_CAUTION = {
  NONE: 'none',
  DELETE_ONLY: 'deleteOnly',
  DELETE_OR_RETAIN: 'deleteOrRetain',
};

export function resolveKrCaution({ dataTypeChanged, timePeriodChanged, cadenceChanged } = {}) {
  if (dataTypeChanged || timePeriodChanged) {
    return KR_CAUTION.DELETE_ONLY;
  }
  if (cadenceChanged) {
    return KR_CAUTION.DELETE_OR_RETAIN;
  }
  return KR_CAUTION.NONE;
}
